export default __webpack_public_path__ + "static/media/logo.c63b6113.png";